export default __webpack_public_path__ + "static/media/cookie.6ead42ad.svg";